import styled from 'styled-components'

export const SkipToError = styled.span`
  text-decoration: underline;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
`
